import { render, staticRenderFns } from "./ContributionsList.vue?vue&type=template&id=75451bb7"
import script from "./ContributionsList.vue?vue&type=script&lang=ts"
export * from "./ContributionsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports